var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-y":"scroll","padding-bottom":"64px"}},[(_vm.identity == 2 || _vm.identity == 3)?_c('shifuUser'):_c('yhUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }